module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section hero"
  }, [_c('div', {
    staticClass: "section__wrapper"
  }, [_c('div', {
    staticClass: "section__content"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'view-home'
      }
    }
  }, [_c('img', {
    staticClass: "hero__heading",
    attrs: {
      "src": require("../assets/BTAB_svg.svg"),
      "alt": "Britain Take A Bow"
    }
  })]), _vm._v(" "), (_vm.isAdmin) ? _c('div', {
    staticClass: "hero__admin-nav"
  }, [_c('p', [_vm._v("Admin user")]), _vm._v(" "), _c('p', [_c('router-link', {
    attrs: {
      "to": {
        name: 'view-user-approval'
      }
    }
  }, [_vm._v("Approve users")])], 1), _vm._v(" "), _c('p', [_c('router-link', {
    attrs: {
      "to": {
        name: 'view-upload'
      }
    }
  }, [_vm._v("Upload")])], 1), _vm._v(" "), _c('p', [_c('router-link', {
    attrs: {
      "to": {
        name: 'view-home'
      }
    }
  }, [_vm._v("Home")])], 1)]) : _vm._e()], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-46f61abf","transformToRequire":{"audio":"src"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppHeader.vue
// module id = 227
// module chunks = 1